import {
	TooltipRoot,
	TooltipTrigger,
	TooltipContent,
	TooltipProvider
} from './Tooltip';

export const Tooltip = {
	Root: TooltipRoot,
	Trigger: TooltipTrigger,
	Content: TooltipContent,
	Provider: TooltipProvider
};
